/**
 * @Description 商圈详情-本品牌门店列表
 * 注意点位测评详情也引用该组件，修改时要注意
 */

import { FC, useEffect, useRef, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Pagination from '@/common/components/Data/V2Pagination';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { getShopList, getShopListShare } from '@/common/api/expandStore/shop';
import StoreItem from './StoreItem';
import styles from './index.module.less';
import ShopDetailDrawer from '@/views/expandstore/pages/shopDetail/Drawer';
import { useGlobalAliases } from '@/common/hook/useGlobalAlias';

export interface StoreListProps {
  detail?: any;
  viewDetail?: boolean;
  isShare?: boolean; // 分享页场景
  tenantId?: number; // 分享页场景
  employeeId?: number; // 分享页场景
  // from?: number; // 1 选址地图青春版详情 2 点位测评详情
  streetPointParams?: any; // 来源是：点位测评街边店时
  isNeedShareAPI?: boolean; // 来源是：点位测评分享时
  noDataPermission?: boolean; // 当前场景是否跳过门店数据权限
}

const StoreList: FC<StoreListProps> = ({
  detail,
  viewDetail,
  isShare,
  isNeedShareAPI,
  noDataPermission = false,
  tenantId,
  employeeId,
  streetPointParams = null, // 来源是：点位测评街边店时(查询的是半径时)
}) => {
  /** 获取全局别名 */
  const {
    standardStoreType: standardStoreTypeAlias, // 门店类型别名
  } = useGlobalAliases();

  const detailRef: any = useRef();
  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(1); // 当前页数
  const [pageSize, setPageSize] = useState<any>(3); // 当前页长
  const [list, setList] = useState<any>([]); // 机会点数据
  const [loading, setLoading] = useState<any>(false); // 当前页数

  useEffect(() => {
    // 点位测评街边店时
    if (streetPointParams && Object.keys(streetPointParams).length > 0) {
      methods.loadData({});
      return;
    }
    const { id } = detail || {};
    id && methods.loadData({});
  }, [detail]);

  const methods = useMethods({
    // 分页相关
    handlePageChange: (value: any, pageSize: number) => {
      setCurrentPage(value);
      setPageSize(pageSize);
      methods.loadData({ page: value, pageSize: pageSize });
    },

    loadData: async (params) => {
      const _params: any = {
        page: params?.page || currentPage,
        size: params?.pageSize || pageSize,
        // 选址地图详情/点位测评商场店时才有id， 点位测评街边店时，是没有id的
        ...(detail?.id ? { modelClusterId: detail.id } : {}),
        // modelClusterId: detail.id,
        ...(streetPointParams || {}),
        ...(noDataPermission ? { noDataPermission: true } : {}),
        ...(isShare || isNeedShareAPI ? { tenantId, userId: employeeId } : {}),
      };

      setLoading(true);
      const targetFetch = isNeedShareAPI ? getShopListShare : getShopList;
      const { objectList, totalNum } = await targetFetch(_params).finally(() => setLoading(false));
      setTotalNum(totalNum);
      setList(isArray(objectList) ? objectList : []);
    },
    onClick(val: any) {
      if (isShare) return;
      if (viewDetail) {
        detailRef.current?.init?.(val.id);
      }
    }
  });

  return (
    <>
      {totalNum ? <div className={styles.storeList}>
        <V2Title divider type='H2' text={`本品牌门店(${totalNum})`}/>
        {list?.map(item => (
          <StoreItem
            key={item.id}
            detail={item}
            streetPointParams={streetPointParams}
            standardStoreTypeAlias={standardStoreTypeAlias}
            onClick={methods.onClick}
            className={viewDetail ? 'pointer' : ''}
          />
        ))}
        {totalNum > pageSize
          ? <V2Pagination
            simple={true}
            disabled={loading}
            current={currentPage}
            total={totalNum}
            onChange={methods.handlePageChange}
            pageSize={pageSize}
          /> : '' }
      </div> : null}
      <ShopDetailDrawer ref={detailRef} reload={methods.loadData} />
    </>
  );
};

export default StoreList;
